module.exports = __webpack_public_path__ + "media/images/athletes/1324-43c11817291a6ececfd866b219006a66.png";